import Home from "./components/Home";
import Convocatoria from "./components/Convocatoria";
import Mision from "./components/Mision";
import Jdd from "./components/Jdd";
import { useState } from "react";
import Equipo from "./components/Equipo";
import Entidades from "./components/Entidades";
import Colabora from "./components/Colabora";
import Contacto from "./components/Contacto";
import Premio from "./components/Premio";
import { BrowserRouter, Route, Routes } from "react-router-dom"
import Docentes from "./components/Docentes";
import Donaciones from "./components/Donaciones";
import QuienesSomos from "./components/QuienesSomos";
import Navidad from "./components/Navidad";


function App() {



  return <BrowserRouter>
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/Convocatoria" element={<Convocatoria/>} />
      <Route path="/Mision" element={<Mision/>} />
      <Route path="/Jdd" element={<Jdd/>} />
      <Route path="/Equipo" element={<Equipo/>} />
      <Route path="/Entidades" element={<Entidades/>} />
      <Route path="/Colabora" element={<Colabora/>} />
      <Route path="/Contacto" element={<Contacto/>} />
      <Route path="/Premio" element={<Premio/>} />
      <Route path="/Docentes" element={<Docentes/>} />
      <Route path="/Donaciones" element={<Donaciones/>} />
      <Route path="/QuienesSomos" element={<QuienesSomos/>} />
      <Route path="/Navidad" element={<Navidad/>} />
    </Routes>
  </BrowserRouter>
}

export default App;
